module.exports = __webpack_public_path__ + "img/share_earn.446047c8.svg";